import { Component } from '@angular/core';
import { ResetPasswordComponent as FsfResetPasswordComponent } from '@freesixtyfive/fe-login-process';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [FsfResetPasswordComponent],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
})
export class ResetPasswordComponent {}
